import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Search } from "@mui/icons-material";
import {
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
} from "@mui/material";
import { Box } from "@mui/system";
import {
  foundListData,
  foundStatuaHandler,
} from "../../redux/action-creators/lostFoundAction";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { RoutingLinks } from "../../utils/constants";
import { CommonButton } from "../../stories/Button";
import { UserCommonStyles } from "../../styles/CommonStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ActionImage from "../../images/action.png";
import SocialIconSection from "../../components/sidebars/SocialIconSection";

const rows = [
  {
    id: 1,
    name: "Pet",
    type: "Dog",
    breed: "Breed",
    color: "Black",
    age: "3 month",
    status: "0",
    action: require("../../images/action.png"),
  },
  {
    id: 2,
    name: "Pet",
    type: "Dog",
    breed: "Breed",
    color: "Black",
    age: "3 month",
    status: "0",
    action: require("../../images/action.png"),
  },
  {
    id: 3,
    name: "Pet",
    type: "Dog",
    breed: "Breed",
    color: "Black",
    age: "3 month",
    status: "0",
    action: require("../../images/action.png"),
  },
  {
    id: 4,
    name: "Pet",
    type: "Dog",
    breed: "Breed",
    color: "Black",
    age: "3 month",
    status: "0",
    action: require("../../images/action.png"),
  },
];

const AdoptionList = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");

  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
  const [listIndex, setList_Index] = useState<number | null>(null);
  const [foundList, setFoundList] = useState<any>([]);
  const [loader, setloader] = useState<boolean>(true);
  const [disabled, setDisabled] = useState<any>({isDisable: false, index: 0});
  const [query, setQuery] = useState<string>("");

  const getFoundList = async () => {
    setloader(true);
    const response: any = await dispatch(foundListData(String(userId)));
    if (response?.statusCode == 201) {
      setFoundList(response?.data);
    } else {
      setFoundList([]);
    }
    setloader(false);
  };

  const handleChange_Dropdown = async (
    index: number,
    id: number,
    user_id: number,
    status: string
  ) => {
    // setList_Index(null);
    // setShowDropdown(false);
    setDisabled({isDisable: true, index: index});
    const data = {
      id,
      user_id,
      status,
    };
    const response: any = await dispatch(foundStatuaHandler(data));
    if (response?.statusCode == 201) {
      getFoundList();
      setDisabled({isDisable: false, index: 0});
    } else {
      setDisabled({isDisable: false, index: 0});
    }
  };

  useEffect(() => {
    getFoundList();
  }, []);

  return (
    <Box>
      <Box className={`${commonStyle.windowColor}`}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
            {/* <SocialIconSection /> */}
          </Grid>

          <Grid item md={9}>
            <Box className={commonStyle.p20}>
              <Box
                className={`
                    ${commonStyle.flexCenter} 
                    ${commonStyle.justifySpaceBetween} 
                    ${commonStyle.alignItemsCenter} 
                    ${commonStyle.mb15} 
                    ${commonStyle.mt20}
                `}
              >
                <Typography
                  variant="h6"
                  style={{ marginBottom: "0px !important" }}
                  className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
                >
                  {"Pet Found"}
                </Typography>
                <Box className={`${commonStyle.flexCenter}`}>
                  <Box className={`${commonStyle.orangeBtn}`}>
                    <CommonButton
                      label={translation("Add Yours")}
                      onClick={() =>
                        history.push(`${RoutingLinks.addLostFound}`)
                      }
                    />
                  </Box>
                </Box>
              </Box>

              <Box className={`${commonStyle.p20} ${commonStyle.card}`}>
                <Box className={commonStyle.headindAndSearch}>
                  <Typography
                    variant="h6"
                    style={{ marginBottom: "0px !important" }}
                    className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
                  >
                    {translation("List")}
                  </Typography>
                  <Box
                    className={`${commonStyle.headerSearch} ${commonStyle.ml10} ${commonStyle.mr10} ${commonStyle.seasrchBar}`}
                  >
                    <TextField
                      style={{ width: 350 }}
                      placeholder={translation("search")}
                      onChange={(e) => setQuery(e.target.value)}
                    ></TextField>
                    <Search />
                    <Search />
                  </Box>
                </Box>
                <Box>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#01B4BC" }}>
                        <TableRow>
                          <TableCell
                            className={commonStyle.tableHeadColumntext}
                          >
                            Pet Name
                          </TableCell>
                          <TableCell
                            className={commonStyle.tableHeadColumntext}
                            align="center"
                          >
                            Type of pet
                          </TableCell>
                          <TableCell
                            className={commonStyle.tableHeadColumntext}
                            align="center"
                          >
                            Color
                          </TableCell>
                          <TableCell
                            className={commonStyle.tableHeadColumntext}
                            align="center"
                          >
                            Status
                          </TableCell>
                          <TableCell
                            className={commonStyle.tableHeadColumntext}
                            align="center"
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {foundList.length > 0 ? (
                          foundList
                            .filter((ele: any) => {
                              if (query === ("" || null || undefined)) {
                                return ele;
                              } else if (
                                ele.name
                                  .toLowerCase()
                                  .includes(query.toLowerCase())
                              ) {
                                return ele;
                              } else {
                                return false;
                              }
                            })
                            .map((row: any, index: number) => {
                              console.log("row", row);
                              return (
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                    textTransform: "capitalize",
                                  }}
                                >
                                  <TableCell
                                    className={commonStyle.tableBodyColumntext}
                                    component="th"
                                    scope="row"
                                  >
                                    {row?.name ? row?.name : ""}
                                  </TableCell>
                                  <TableCell
                                    className={commonStyle.tableBodyColumntext}
                                    align="center"
                                  >
                                    {row?.type ? row?.type : ""}
                                  </TableCell>

                                  <TableCell
                                    className={commonStyle.tableBodyColumntext}
                                    align="center"
                                  >
                                    {row?.color ? row?.color : ""}
                                  </TableCell>

                                  <TableCell
                                    className={commonStyle.tableBodyColumntext}
                                    align="center"
                                  >
                                    <Box
                                      sx={{
                                        minWidth: 110,
                                        height: 40,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 68,
                                          height: 22,
                                          borderRadius: 13.5,
                                          backgroundColor:
                                            row.status == "user_founds"
                                              ? "#ccf0f2"
                                              : "#ffcccc",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          marginLeft: "auto",
                                          marginRight: "auto",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color:
                                              row.status == "user_founds"
                                                ? "#01B4BC"
                                                : "#D95557",
                                          }}
                                        >
                                            { row?.status === "user_founds"
                                            ? "Active"
                                            : row?.status === "user_losts" &&
                                              "Inactive"}
                                        </p>
                                      </Box>
                                    </Box>
                                    {/* {showDropdown && listIndex == index ? (
                                      <Box
                                        sx={{
                                          marginLeft: "auto",
                                          marginRight: "auto",
                                        }}
                                      >
                                        <FormControl>
                                          <Select
                                            style={{
                                              width: 110,
                                              height: 40,
                                              borderWidth: 1,
                                              borderColor: "#01B4BC",
                                            }}
                                            value={row.status === "user_founds" ? "Active" : "Inactive"}
                                            onChange={(event: any) =>
                                              handleChange_Dropdown(
                                                row?.id,
                                                row?.userId,
                                                row?.status
                                              )
                                            }
                                            displayEmpty
                                            inputProps={{
                                              "aria-label": "Without label",
                                            }}
                                          >
                                            <MenuItem value={"0"}>
                                              Active
                                            </MenuItem>
                                            <MenuItem value={"1"}>
                                              Inactive
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    ) : (
                                    )} */}
                                  </TableCell>
                                  <TableCell align="center">
                                    <Box className={`${commonStyle.orangeBtn}`}>
                                      <CommonButton
                                        label={
                                          row?.status === "user_founds"
                                            ? "Inactive"
                                            : row?.status === "user_losts" &&
                                              "Active"
                                        }
                                        disabled={disabled.isDisable && disabled.index === index}
                                        onClick={() =>
                                          handleChange_Dropdown(
                                            index,
                                            row?.id,
                                            row?.userId,
                                            row?.status === "user_founds"
                                            ? "user_losts"
                                            : row?.status === "user_losts" &&
                                              "user_founds"
                                          )
                                        }
                                      />
                                    </Box>
                                    {/* <Box>
                                      <img
                                        src={ActionImage}
                                        alt="react logo"
                                        style={{
                                          width: 20,
                                          height: 20,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setShowDropdown(!showDropdown);
                                          setList_Index(index);
                                        }}
                                      />
                                    </Box> */}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        ) : loader ? (
                          <Typography
                            mt={2}
                            mb={2}
                            ml={2}
                            className={`${commonStyle.bold2}`}
                          >
                            {translation("loading")}
                          </Typography>
                        ) : (
                          <Typography
                            mt={2}
                            mb={2}
                            ml={2}
                            className={`${commonStyle.bold2}`}
                          >
                            {translation("missing_record")}
                          </Typography>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AdoptionList;
